export interface ApiGetEmbodimentKeywordsRequest {
    task_id: string;
    concept: string;
    num: string;
}

export interface ApiGetEmbodimentKeywordsResponse {
    hypernym: string[];
    parallel: string[];
    hyponym: string[];
}

export const GetEmbodimentKeywordsApi = Symbol.for('GetEmbodimentKeywordsApi');

export interface GetEmbodimentKeywordsApi {
    getEmbodimentKeywords(data: ApiGetEmbodimentKeywordsRequest): Promise<ApiGetEmbodimentKeywordsResponse>;
}
